<div *ngIf="activeQuestion" [formGroup]="activeQuestion" class="randomized-setting__container">
  <mat-slide-toggle
    [class.border]="showBorder"
    [labelPosition]="'before'"
    [color]="'primary'"
    formControlName="randomizedOptionsInd"
    [checked]="activeQuestion.value.randomizedOptionsInd"
  >
    Randomized Options
  </mat-slide-toggle>
</div>
